<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">

        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Schedule Tasks</h2>

            <button class="btn wide" @click="createNew">
                <i class="ico-add large"></i>
                Create New
            </button>
        </div>

        <!-- Lower area -->
        <div class="overflow-auto flexGrow1">

            <!-- white area -->
            <div class="px-3 py-4 d-flex">
                <div class="col-sm-12 bg-lightest">


                    <!-- Table -->
                    <div v-if="isLoadingTable" class="p-4 text-center mb-4">
                        <loader></loader>
                    </div>

                    <div v-else-if="getScheduledTasks.length == 0" class="text-center dark p-4 my-4">
                        <span class="">📎 You have no scheduled tasks yet. <span class="bold underlined pointer" @click="createNew">Create one here</span>.</span>
                    </div>

                    <div v-else>
                        <!-- Pagination -->
                        <div class="d-flex justify-content-end my-4">
                            <uib-pagination v-if="currentPagination.numPages > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchItems"></uib-pagination>
                        </div>

                        <!-- Content list -->
                        <list :header="header" :body="body" :rows="tableRows" :actions="actions" :showNoDataMessage="false"></list>

                        <!-- Pagination -->
                        <div class="d-flex justify-content-end my-4">
                            <uib-pagination v-if="currentPagination.numPages > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchItems"></uib-pagination>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import vSelect from 'vue-select'
import List from '@/tools/list/baseList'
import {promocodesMixin} from '@/mixins/promocodes'
import Loader from '@/tools/loaders/loader1'
import cronstrue from 'cronstrue';

// ComponentModal
import taskHistory from '@/components/scheduleTasks/components/taskHistoric'

export default {
    mixins:[
        promocodesMixin,
    ],
    data: function () {
        return {
            currentPagination: {
                currentPage: 1,
                numPages:1
            },
            paginationSettings: {
                itemsPerPage: 25,
                totalItems: 0
            },
            actions: {
                label : 'Actions',
                alwaysVisible: true,
                list: [
                    {
                        slug: 'delete',
                        title: 'Delete',
                        tooltip: 'Delete',
                        params: '',
                        class: '',
                        icon: 'ico-delete largest',
                        event: this.setDeleteScheduleTask
                    },
                    {
                        slug: 'pause',
                        title: 'Pause',
                        tooltip: 'Pause',
                        params: '',
                        class: '',
                        icon: 'fas fa-pause largest',
                        event: this.setPauseScheduleTask
                    },
                    {
                        slug: 'publish',
                        title: 'Publish',
                        tooltip: 'Publish',
                        params: '',
                        class: '',
                        icon: 'fas fa-play largest',
                        event: this.setResumeScheduleTask
                    },
                    {
                        slug: 'history',
                        title: 'History',
                        tooltip: 'See History',
                        params: '',
                        class: '',
                        icon: 'fas fa-history largest',
                        event: this.seeTaskHistory
                    },
                ],
            }
        }
    },
    created: function () {
        this.fetchItems()
    },
    computed: {
        ...mapGetters([
            'getScheduledTasks',
            'getIsLoadingScheduledTasks',
            'getTypeOptions',
            'getSalesChannelsForNewProduct',
            'getAgents',
            'getIsLoadingAssociatedAgent',
            'getTaskStates'
        ]),
        isLoadingTable: function () {
            return this.getIsLoadingScheduledTasks || this.getIsLoadingAssociatedAgent || this.getSalesChannelsForNewProduct.length < 1
        },
        tableRows: function () {
            return this.getScheduledTasks
        },
        header: function () {
            let vm = this
            return {
                selection: {
                    active: false,
                    event: function(event) {}
                },
                list: {
                    type: 'Type',
                    name: 'Name',
                    details: 'Details',
                    repetition: 'Repetition'
                },
                customClassCell:{
                    status: 'scheduleTaskListStatus text-center',
                    type: 'scheduleTaskListType',
                    repetition: 'scheduleTaskListRepetition',
                    // products: 'w-50',
                }
            };
        },
        body: function() {
            let vm = this;

            return {
                selection: {
                    active: false,
                    event: function(event, row) {}
                },
                customRowEvent: function(row) { vm.viewScheduleTask(row)},
                customCells: {
                    type: (row) => {
                        if(row.loading && row.loading == true){
                            return '<div class="loaderHolder"><div class="loader">Loading...</div></div>'
                        }

                        let output = '<div>'
                        // Type
                        output += '<div>'+this.decodeType(row)+'</div>'
                        //Status
                        output += this.decodeStatus(row)

                        output += '</div>'
                        return output
                    },
                    name: (row) => {
                        return row.name? row.name : 'No name provided'
                    },
                    details: (row) => {
                        return this.buildDetailsCell(row)
                    },
                    repetition: function (row) {
                        let output = ''
                        output += '<div>' + cronstrue.toString(row.cron, { use24HourTimeFormat: true }) + '</div>'
                        output += '<div>'
                        output += row.lastExecutionDate? '<span> <b>Previous:</b> ' + moment(row.lastExecutionDate).format('DD/MM/YYYY')  + '</span>' : ''
                        output += '<span> <b>Next:</b> ' + moment(row.nextExecutionDate).format('DD/MM/YYYY')  + '</span>'
                        output += '</div>'
                        return output
                    },
                },
                customClassCell: {
                    status : 'pointer text-center',
                    type : 'pointer',
                    details : 'pointer',
                    repetition : 'pointer',
                },
                // rowEvent: this.view(event),
            }
        },
    },
    methods: {
        ...mapActions([
            'downloadScheduledTasks',
            'selectScheduleTask',
            'deleteScheduledTask',
            'pausePromocode',
            'resumePromocode',
            'setSelectedPromocode',
            'openComponentModal',
            'openModal',
            'pauseScheduleTask',
            'resumeScheduleTask',
        ]),
        fetchItems: function () {

            this.downloadScheduledTasks({
                paginationSettings: this.paginationSettings,
                currentPage: this.currentPagination.currentPage
            }).then(response => {
                this.paginationSettings.totalItems = response.data.pageInfo.totalItemCount
                this.currentPagination.numPages = response.data.pageInfo.pageCount
            })
        },
        decodeType: function (scheduleTask) {
            let foundType = this.getTypeOptions.find(type => {
                return type.id == scheduleTask.taskType
            })

            if(foundType){
                return foundType.label
            } else {
                return '-'
            }
        },
        decodeStatus: function (scheduleTask) {
            let foundStatus = this.getTaskStates.find(state => {
                return state.id == scheduleTask.taskStatus
            })
            if(foundStatus){
                return `<div><span class="px-2 py-0 radius-normal fs-smaller bold bg-${foundStatus.color1} ${foundStatus.color2}">${foundStatus.label}</span></div>`
            } else {
                return false
            }
        },
        buildDetailsCell: function (scheduleTask) {
            let output = ''

            if(scheduleTask.taskType = 10000){
                // parse jsonParameters
                if(scheduleTask.jsonParameters){
                    let jsonParametersObject = JSON.parse(scheduleTask.jsonParameters)
                    let channelsArray = []
                    let agentsArray = []

                    // List Sales Channels
                    if(jsonParametersObject.channelIdList && jsonParametersObject.channelIdList.length > 0){
                        channelsArray = jsonParametersObject.channelIdList.map(channelId => {
                            let matchChannel = this.getSalesChannelsForNewProduct.find(channel => {
                                return channel.channelId == channelId
                            }).brandName

                            return matchChannel
                        })

                        output += '<b>Channels:</b> ' + channelsArray.join(', ') + '<br>'
                    }

                    // List Agents
                    if(jsonParametersObject.agentIdList && jsonParametersObject.agentIdList.length > 0){
                        agentsArray = jsonParametersObject.agentIdList.map(agentId => {
                            let matchAgent = this.getAgents.find(agent => {
                                return agent.id == agentId
                            }).brandName

                            return matchAgent
                        })

                        output += '<b>Agents:</b> ' + agentsArray.join(', ')
                    }


                    return output
                }

            }
        },
        paginationChanged: function (e) {
        },
        createNew: function () {
            this.openModal('ScheduleTaskCreate')
        },
        viewScheduleTask: function (row) {
            this.selectScheduleTask(JSON.parse(JSON.stringify(row)))
            this.openModal('ScheduleTaskEdit')
            return false
            this.$router.push({name:'editpromocode'})
        },
        /// ----------------- ACTIONS -----------------
        setDeleteScheduleTask: function (row) {
            this.$dialog.confirm('\
            <div class="fs-larg font-weight-600 mb-4">Delete schedule task?</div>\
            <div>Are you sure you want to delete this schedule task?</div>')
            .then(() => {
                this.$set(row, 'loading', true)
                this.deleteScheduledTask(row).then(response => {
                    this.fetchItems()
                })
            }).catch(function () {

            });
        },
        setPauseScheduleTask: function (row) {
            this.$set(row, 'loading', true)
            this.pauseScheduleTask(row).then(response => {
                this.fetchItems()
            })
        },
        setResumeScheduleTask: function (row) {
            this.$set(row, 'loading', true)
            this.resumeScheduleTask(row).then(response => {
                this.fetchItems()
            })
        },
        seeTaskHistory: function (row) {
            this.selectScheduleTask(JSON.parse(JSON.stringify(row)))
            this.openComponentModal(taskHistory)
        },
    },
    components: {
        vSelect,
        List,
        Loader
    }
}
</script>

<style lang="scss">
@import "~@/assets/scss/_variables.scss";

.taskStatusBall{
    height: 10px;
    width: 10px;
    background-color: silver;
    border-radius: 100%;
    display: inline-block;

    &.active{
        background-color: $green;
    }

    &.notActive{
        background-color: $red;
    }
}

.scheduleTaskListStatus{
    width: 1%;
}
.scheduleTaskListType{
    width: 180px;
}
.scheduleTaskListRepetition{
    width: 280px;
}
</style>



// WEBPACK FOOTER //
// scheduleTasks.vue?2484583a